import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { DefaultMira } from '@irohalab/mira-sdk-angular';
import { filter, map, Subscription, switchMap } from 'rxjs';

import { UIResponsiveImageWrapper, UIToast, UIToastComponent, UIToastRef } from '@irohalab/deneb-ui';
import { NavbarComponent } from '../navbar/navbar.component';
import { UserActionComponent } from '../user-action/user-action.component';

@Component({
    selector: 'app-search-results',
    imports: [RouterLink, UIResponsiveImageWrapper, NavbarComponent, UserActionComponent],
    templateUrl: './search-results.component.html',
    styleUrl: './search-results.component.less'
})
export class SearchResultsComponent implements OnInit, OnDestroy {
  private subscription = new Subscription();
  private toastRef: UIToastRef<UIToastComponent>
  results: any[] = [];
  query: string = '';


  constructor(private route: ActivatedRoute,
              private miraService: DefaultMira,
              toastService: UIToast) {
    this.toastRef = toastService.makeText();
  }

  ngOnInit(): void {
    this.subscription.add(
      this.route.queryParams.pipe(
        map(params => params['search_query']),
        filter(searchQuery => searchQuery),
        switchMap((searchQuery: string) => {
          this.query = searchQuery;
          return this.miraService.listMainItems(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, searchQuery);
        })
      ).subscribe({
        next: response => {
          this.results = response.data;
        },
        error: error => {
          this.toastRef.show(error.message || error);
        }
      })
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
